import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { societesService, societesMeresService } from "../../services";
import { CustomDialog, showToast } from "..";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../utils/UserProvider";

interface ModalAddSocieteProps {
  closeModalSociete: () => void;
  modalIsOpenSociete: boolean;
  openModalActif: () => void;
}
const ModalAddSociete = ({
  closeModalSociete,
  modalIsOpenSociete,
  openModalActif,
}: ModalAddSocieteProps) => {
  const queryClient = useQueryClient();
  const { client } = useAuth();

  const [loading, setLoading] = useState<boolean>(false);
  const [societemere, setSocieteMere] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchSocietesMeres = async () => {
      try {
        setLoading(true);
        const response = await societesMeresService.getAll();
        setSocieteMere(response);
        setLoading(false);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };
    fetchSocietesMeres();
  }, []);

  const onSubmit = async (data: any) => {
    try {
      const SocieteData = {
        nom_societe: data.nom_societe,
        numéro_propriétaire:data.numéro_propriétaire,
        numéro_fiscal: data.numéro_fiscal,
        env_client_id: client.id,
        ...(data.numéro_siren !== undefined && data.numéro_siren !== ""
          ? { numéro_siren: data.numéro_siren }
          : {}),
        ...(data.societe_mere_id !== undefined && data.societe_mere_id !== ""
          ? { societe_mere_id: parseInt(data.societe_mere_id, 10) }
          : {}),
        ...(data.adresse_siege_social !== undefined &&
        data.adresse_siege_social !== ""
          ? { adresse_siege_social: data.adresse_siege_social }
          : {}),
      };
      setLoading(true);
      await societesService.post(SocieteData).then(() => {
        setLoading(false);
        showToast("success", "Société ajouté avec succès");
        queryClient.refetchQueries({
          queryKey: ["societes"],
        });
        reset({
          nom_societe: "",
          numéro_siren: "",
          societe_mere_id: "",
          adresse_siege_social: "",
        });
        closeModalSociete();
        openModalActif();
      });
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  return (
    <CustomDialog
      header="Ajouter une nouvelle société"
      visible={modalIsOpenSociete}
      closeModalDialog={() => {
        reset({
          nom_societe: "",
          numéro_siren: "",
          societe_mere_id: "",
          adresse_siege_social: "",
        });

        closeModalSociete();
      }}
      customStyle={{ width: "50vw" }}
    >
      <div className="w-full h-full">
        <div className="p-6 space-y-6">
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="nom_societe"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Nom société *
              </label>
              <input
                type="text"
                name="nom_societe"
                id="nom_societe"
                placeholder="Saisir nom"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("nom_societe", {
                  required: true,
                })}
              />
              {errors.nom_societe && (
                <span className="bg-red-100 text-red-800 text-sm font-medium mr-2 my-4  px-2 py-1 rounded ">
                  champs obligatoire
                </span>
              )}
            </div>
            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="numéro_siren"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Numéro SIREN
              </label>
              
              <input
                type="text"
                name="numéro_siren"
                id="numéro_siren"
                placeholder="Saisir numéro SIREN"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("numéro_siren", {
                  required: true,
                  pattern: {
                    value: /^[A-Z]{2}[0-9]{9,12}$/,
                    message: "Format invalide (ex : FR123456789)"
                }
                })
              }
               
              />
              {errors.numéro_siren && (
                <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                  {errors.numéro_siren?.message as string}
                </span>
              )}
            </div>



            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="numéro_fiscal"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Numéro fiscal
              </label>
              
              <input
                type="text"
                name="numéro fiscal"
                id="numéro_fiscal"
                placeholder="Saisir numéro fiscal"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("numéro_fiscal", {
                  required: true,
                  pattern: {
                    value: /^[A-Za-z0-9]+$/,
                    message: "Format invalide "
                }
                })
              }
               
              />
              {errors.numéro_fiscal && (
                <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                  {errors.numéro_fiscal?.message as string}
                </span>
              )}
            </div>



            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="numéro_propriétaire"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Numéro de propriétaire
              </label>
              
              <input
                type="text"
                name="numéro de propriétaire"
                id="numéro_propriétaire"
                placeholder="Saisir numéro de propriétaire"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("numéro_propriétaire", {
                  required: true,
                  pattern: {
                    value: /^[A-Za-z0-9]+$/,
                    message: "Format invalide "
                }
                })
              }
               
              />
              {errors.numéro_propriétaire && (
                <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                  {errors.numéro_propriétaire?.message as string}
                </span>
              )}
            </div>




            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="adresse_siege_social"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Adresse siége social
              </label>

              <input
                type="text"
                name="adresse_siege_social"
                id="adresse_siege_social"
                placeholder="Saisir adresse siége"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("adresse_siege_social")}
              />
            </div>
            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="nom_societe"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Société mère
              </label>
              <select
                id="societe_mere_id"
                name="societe_mere_id"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("societe_mere_id")}
              >
                <option value={""}>Aucune</option>
                {societemere?.map((societe) => (
                  <option key={societe?.id} value={societe?.id}>
                    {societe?.nom_societe_mere}
                  </option>
                ))}
              </select>
            </div>
            <p className=" text-lg font-thin my-4">* obligatoire</p>

            <div className="flex justify-end space-x-2 mt-10">
              <button
                type="submit"
                className="text-white bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
              >
                {loading && (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 mr-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                )}
                Ajouter
              </button>
              <button
                type="button"
                onClick={() => {
                  closeModalSociete();
                  reset({
                    nom_societe: "",
                    numéro_siren: "",
                    societe_mere_id: "",
                  });
                }}
                className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-2  text-center "
              >
                Retour
              </button>
            </div>
          </form>
        </div>
      </div>
    </CustomDialog>
  );
};

export default ModalAddSociete;
